/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'basic/reload-1214298': {
    width: 16,
    height: 16,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M21 11a1 1 0 00-1 1 8.05 8.05 0 11-2.22-5.5h-2.4a1 1 0 000 2h4.53a1 1 0 001-1V3a1 1 0 00-2 0v1.77A10 10 0 1022 12a1 1 0 00-1-1z"/>'
  }
})
